module.exports = __webpack_public_path__ + "img/elderly-card.30e5bcb3.png";